
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/your-type",
      function () {
        return require("private-next-pages/your-type/index.page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/your-type"])
      });
    }
  